import { guideBySlug } from '@/modules/marketing/guides';

/**
 * Where a documentation link goes for somebody signed in.
 *
 * Pages link to each other by their public addresses (`/docs/...`). In the dashboard the same pages
 * live under `/help`, so a customer following a link stays in the dashboard rather than being sent
 * to the marketing site. Links that have no dashboard page, such as the feature articles, keep their
 * public address.
 */
export function helpLink(href: string): string {
  const hashAt = href.indexOf('#');
  const path = hashAt === -1 ? href : href.slice(0, hashAt);
  const anchor = hashAt === -1 ? '' : href.slice(hashAt);

  if (path === '/docs' || path === '/docs/') {
    return `/help${anchor}`;
  }

  const reference = /^\/docs\/(playbooks|templates)(\/[a-z0-9-]+)?$/.exec(path);

  if (reference !== null) {
    return reference[2] === undefined ? `/help#${reference[1]}` : `/help/${reference[1]}${reference[2]}${anchor}`;
  }

  if (path === '/docs/troubleshooting') {
    return `/help/troubleshooting${anchor}`;
  }

  const guide = /^\/docs\/([a-z0-9-]+)$/.exec(path);

  if (guide !== null && guideBySlug(guide[1] ?? '') !== undefined) {
    return `/help/guides/${guide[1]}${anchor}`;
  }

  return href;
}

/** Public pages link to public pages. */
export function publicLink(href: string): string {
  return href;
}
